/* manually created to match existing facades + API */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentSigningService {
  /**
   * Get signing context for a document
   * GET /documents/{document}/signing-context
   */
  public static getSigningContext(
    documentId: number,
  ): CancelablePromise<{
    success?: boolean;
    data?: Record<string, any>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/documents/{document}/signing-context',
      path: {
        document: documentId,
      },
      errors: {
        401: 'Unauthenticated',
        404: 'Document not found',
      },
    });
  }

  /**
   * Submit a signature for a document
   * POST /documents/{document}/signatures
   */
  public static submitSignature(
    documentId: number,
    requestBody: {
      signature_data: string;
      status?: string;
    },
  ): CancelablePromise<{
    success?: boolean;
    data?: Record<string, any>;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/documents/{document}/signatures',
      path: {
        document: documentId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: 'Unauthenticated',
        404: 'Document not found',
        422: 'Validation error',
      },
    });
  }

  /**
   * List signatures for a document
   * GET /documents/{document}/signatures
   */
  public static listSignatures(
    documentId: number,
  ): CancelablePromise<{
    success?: boolean;
    data?: Record<string, any>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/documents/{document}/signatures',
      path: {
        document: documentId,
      },
      errors: {
        401: 'Unauthenticated',
        404: 'Document not found',
      },
    });
  }

  /**
   * Get a specific signature
   * GET /documents/{document}/signatures/{signature}
   */
  public static getSignature(
    documentId: number,
    signatureId: number,
  ): CancelablePromise<{
    success?: boolean;
    data?: Record<string, any>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/documents/{document}/signatures/{signature}',
      path: {
        document: documentId,
        signature: signatureId,
      },
      errors: {
        401: 'Unauthenticated',
        404: 'Signature not found',
      },
    });
  }

  /**
   * Download signed PDF
   * GET /documents/{document}/signed-pdf
   */
  public static downloadSignedPdf(
    documentId: number,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/documents/{document}/signed-pdf',
      path: {
        document: documentId,
      },
      errors: {
        401: 'Unauthenticated',
        404: 'Document not found',
      },
    });
  }
}

